import {
  RECOVERY_OTP_CONFIRM_CANCEL,
  RECOVERY_OTP_CONFIRM_CONTINUE,
  RECOVERY_OTP_CONFIRM_MESSAGE,
  RECOVERY_OTP_CONFIRM_TITLE,
} from '../../constants/ui.labels'
import ContentHeader from '../ContentHeader'
import RecoveryOTPBox from '../RecoveryOTPBox/index'
import IconWithProvider from '@talkdesk/cobalt-react-icon'
import Flex from '@talkdesk/cobalt-react-flex'
import Button from '@talkdesk/cobalt-react-button'
import { Portal } from '@talkdesk/cobalt-react-portal-provider'
import Modal, { Dialog } from '@talkdesk/cobalt-react-modal'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'
import Box from '@talkdesk/cobalt-react-box'

const EMPTY_LIST = []

const RenderConfirm = ({ onDismiss, onConfirm }) => {
  const theme = useTheme()
  return (
    <Flex direction='column' alignX='center'>
      <Flex direction='column' alignX='center' padding='4' gap='2'>
        <IconWithProvider
          name='error_circle_outline'
          size='large'
          color={theme.gray500}
        />
        <ContentHeader
          title={RECOVERY_OTP_CONFIRM_TITLE}
          message={RECOVERY_OTP_CONFIRM_MESSAGE}
        />
        <Flex gap='2' paddingTop='4'>
          <Button htmlType='button' type='secondary' onClick={onDismiss}>
            {RECOVERY_OTP_CONFIRM_CANCEL}
          </Button>
          <Button htmlType='button' onClick={onConfirm}>
            {RECOVERY_OTP_CONFIRM_CONTINUE}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}

const RenderCodes = ({ otpList, fileTitle, fileName }) => (
  <RecoveryOTPBox otpList={otpList} fileTitle={fileTitle} fileName={fileName} />
)

const RecoveryOTPConfirm = ({
  onDismiss,
  onConfirm,
  otpList = EMPTY_LIST,
  fileTitle,
  fileName,
}) => {
  const theme = useTheme()
  return (
    <Portal>
      <Modal size='small' visible>
        <Flex alignX='end' paddingBottom='2'>
          <IconWithProvider
            name='close'
            size='small'
            color={theme.white}
            onClick={onDismiss}
          />
        </Flex>
        <Dialog>
          <Flex scrollable padding={['3', '5', '6']}>
            {otpList.length > 0 ? (
              <Box width='100%'>
                <RenderCodes
                  otpList={otpList}
                  fileTitle={fileTitle}
                  fileName={fileName}
                />
              </Box>
            ) : (
              <RenderConfirm onDismiss={onDismiss} onConfirm={onConfirm} />
            )}
          </Flex>
        </Dialog>
      </Modal>
    </Portal>
  )
}

export default RecoveryOTPConfirm
